import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { allevaOrangeColor } from '../md/assets/jss/material-dashboard-pro-react.jsx';

const allevaOrange = allevaOrangeColor[0];

/* Call something like this
    <AAutofill
      label="Some label"
      options={<an array of strings>}
      value={<initial choice>}
      onChange={<chosenString> => this.setState({ someStateVar: chosenString })}
    />
 */

const styles = (theme) => ({
  root: {},
});

class AAutofill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenOption: props.value,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({ chosenOption: this.props.value });
    }
  }

  render() {
    const { classes, required } = this.props;
    let label = this.props.label;
    let inputLabelProps = {};

    if (required) {
      label += ' *';
      inputLabelProps = { style: { color: allevaOrange } };
    }

    return (
      <Autocomplete
        className={classes.root}
        blurOnSelect={true}
        options={this.props.options}
        getOptionLabel={(option) => option}
        value={this.state.chosenOption}
        renderInput={(params) => (
          <TextField {...params} label={label} InputLabelProps={inputLabelProps} variant="standard" />
        )}
        onChange={(event, value) => {
          this.setState({ chosenOption: value });
          this.props.onChange(value);
        }}
      />
    );
  }
}

export default withStyles(styles)(AAutofill);
